import client, {ConfigWithToken, get} from './client'

// export const getEmailDetails = async (sub_project_id: any, template_id: any, uuid: any) =>{
//   try {
//   return await client.get(
//     `hse/subproject/${sub_project_id}/template/${template_id}/session/${uuid}/data`, ConfigWithToken()
//     ).then(response=>response.data)
//   }catch(err){
//     return Promise.reject(err);
//   }
// }
export const getEmailDetails = async (sub_project_id: any, template_id: any, uuid: any) =>{
 return await client.get(
  `hse/subproject/${sub_project_id}/template/${template_id}/data?session=${uuid}`, ConfigWithToken()
  ).then(
    response=>response.data
  ).catch(
    error => Promise.reject(error))
}


export const approveSpiEmail = async (sub_project_id: any, template_id: any, uuid: any, status:string) =>{
  return await client.get(
   `hse/subproject/${sub_project_id}/template/${template_id}/email-status?session=${uuid}&status=${status}`, ConfigWithToken()
   ).then(
     response=>response.data
   ).catch(
     error => Promise.reject(error))
 }